@use "../../../../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .container {
        position: relative;
        display: inline-block;
        // it is needed to display cursor around image correctly
        margin: 0 1px;
      }

      .image {
        display: block;
        pointer-events: none;
      }

      .delete {
        position: absolute;
        top: 0.5em;
        left: 0.5em;
      }

      .resizer {
        position: absolute;
        border: 2px solid colors.$mmc-primary;
      }

      .resizeControl {
        width: 0.5rem;
        height: 0.5rem;
        background-color: colors.$mmc-primary;
        position: absolute;
        border: 2px solid colors.$mmc-white;
      }

      .toolbar {
        display: flex;
        flex-direction: column;
      }

      .toolbarRow {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }

      .divider {
        width: 1px;
        height: 1rem;
        background-color: colors.$mmc-disabled-gray;
      }

      .removeControl {
        color: colors.$mmc-red-100;
      }

      .altModalContent {
        padding-top: 0.5rem;
      }

      .altModalCaption {
        color: colors.$mmc-soft-slate;
      }

      .linkContainer {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        font-size: 0.875rem;
        line-height: 1.375rem;
      }

      .linkLabel {
        color: colors.$mmc-soft-slate;
      }

      .linkUrl {
        margin-bottom: 0;
        max-width: 18rem;
        text-wrap: nowrap;
        font-weight: 500;
      }

      .popover {
        :global(.ant-popover-inner) {
          border: 0;
        }

        :global(.ant-popover-inner-content) {
          padding: 0.25rem 0.5rem;
          box-shadow: 0 0.25rem 0.75rem 0 rgba(0, 0, 0, 0.15);
          border-radius: 0.25rem;
        }
      }
    }
  }
}
